{
  "resource.label": "Память",
  "resource.node": "Фрагмент памяти",
  "resource.insufficient": "Недостаточно памяти",
  "unit.worker": "Engineer",
  "unit.melee": "Wheeled IFV",
  "unit.ranged": "Heavy Tank",
  "unit.siege": "Self-Propelled Artillery",
  "worker.task.idle": "Ожидание",
  "worker.task.moveToNode": "Сдвиг к фрагменту",
  "worker.task.gathering": "Сборка",
  "worker.task.moveToHq": "Возврат",
  "worker.task.depositing": "Фрагмент восстановлен",
  "worker.task.building": "Сборка узла",
  "entity.hq": "Command Hub",
  "entity.barracks": "Field Factory",
  "entity.mineral": "Фрагмент памяти",
  "command.train.worker": "Train Engineer",
  "command.train.melee": "Produce IFV",
  "command.train.ranged": "Produce Heavy Tank",
  "command.train.siege": "Produce Artillery",
  "command.buildBarracks": "Build Factory",
  "command.buildBarracks.unlocks": "Unlocks:",
  "command.stop": "Стоп",
  "command.move": "Марш",
  "command.attack": "Атака",
  "command.hold": "Удерживать",
  "command.harvest": "Собирать",
  "cursor.build": "Строительство",
  "hotkey.assign": "Назначить",
  "hotkey.recall": "Вызвать",
  "hotkey.add": "Добавить",
  "alert.invalidBuildPlacement": "Нельзя строить здесь",
  "alert.underAttack": "Узел под атакой",
  "hud.minimap.label": "Мини-карта",
  "selection.none": "Нет выбора",
  "selection.units": "ед.",
  "stat.role": "Роль",
  "stat.hp": "ОЗ",
  "stat.damage": "Урон",
  "stat.range": "Дальность",
  "stat.rangeShort": "Дальн.",
  "stat.aoe": "Область",
  "stat.aoeShort": "Обл.",
  "stat.speed": "Скорость (клеток/с)",
  "stat.speedShort": "Скор. (клеток/с)",
  "stat.cooldown": "Перезарядка",
  "stat.cooldownShort": "КД",
  "stat.cost": "Цена",
  "stat.trainTime": "Подготовка",
  "stat.strongVs": "Силен против",
  "stat.weakVs": "Слаб против",
  "stat.strong": "Силен",
  "stat.weak": "Слаб",
  "stat.cargo": "Груз",
  "stat.none": "нет",
  "stat.secondsSuffix": "с",
  "stat.ticksSuffix": "тиков",
  "stat.ticksShortSuffix": "т",
  "counter.utility": "служебные цели",
  "counter.neutral": "нейтрально",
  "counter.buildings": "здания",
  "briefing.line": "Протокол восстановления активен. Память собрать, помехи удалить."
}
